<template>
  <v-progress-circular
  indeterminate
  :size="size"
  :color="color"/>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#DF9811"
    },
    size: {
      type: String,
      default: "20"
    }
  }
}
</script>

<style>

</style>